export const usercentricsServices = {
    jsdelivr: 'F-REmjGq7',
    matomo: 'u6fxocwTs',
    question_pro: 'nZ9QoSM-0WUuMK',
    salesforce_interactions: 'wFxuQvYX8MhkWv',
    sentry: 'rH1vNPCFR',
    spotify: 'CguMb4Rq',
    storyblok: 'BkW7DxlpN',
    usercentrics_cmp: 'H1Vl5NidjWX',
    youtube: 'BJz7qNsdj-7',
    vimeo: 'HyEX5Nidi-m',
    google_tag_manager: 'BJ59EidsWQ',
    google_analytics: 'HkocEodjb7',
    google_maps: 'S1pcEj_jZX'
} as const;

export type UsercentricsServiceKey = keyof typeof usercentricsServices;

export const getUsercentricsServiceId = (key: UsercentricsServiceKey): string => {
    return usercentricsServices[key];
};
